// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2VrPq","delete":"styles_delete__28alv","update":"styles_update__2wC9W","add":"styles_add__2a9Zy"};